import { Group } from '@/domain/products/types';
import { Chip } from '@andritzot/metris-web-ui/data-display/chip';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import React from 'react';

interface GroupContentProps {
  ProductGroup: Group;
}

const GroupContent: React.FC<GroupContentProps> = ({ ProductGroup }) => {
  return (
    ProductGroup?.productGroup && (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', m: 2, gap: 2 }}>
        <Box>
          <Chip label={ProductGroup.productGroup} variant="outlined" color="primary" />
        </Box>
      </Box>
    )
  );
};

export default GroupContent;
